<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="pa-2 pt-0" flat>
        <v-card-title>افزودن ویدئو</v-card-title>
        <v-card-subtitle>
          برای استفاده از ویدئو با لینک خارجی، لطفا فیلدهای زیر را پر نمایید
        </v-card-subtitle>
        <v-alert
          dense
          type="info"
          text
          border="left"
          class="mb-4 text-right"
        >
          <div class="text-subtitle-2 font-weight-bold mb-2">راهنمای افزودن ویدئو:</div>
        <ul style="list-style-type: none; padding-right: 0; margin: 0; font-size: 0.9rem;">
            <li class="mb-1">
              <i class="fas fa-chevron-left"></i> با کلیک روی <b>آیکون لینک</b> کنار کادر، کادر ورودی برای دریافت کد <code>iframe</code> آماده می‌شود.
            </li>
            <li class="mb-1">
              <i class="fas fa-chevron-left"></i> پس از ثبت، اگر ویدئو در <b>بخش پیش‌نمایش زیرین</b> نمایش داده شد، به معنای صحت لینک و قابل پخش بودن آن است.
            </li>
            <li>
              <i class="fas fa-chevron-left"></i> در صورتی که پیش‌نمایشی ظاهر نشد، فرمت لینک پشتیبانی نمی‌شود؛ لطفاً از ویدئو یا لینک جایگزین استفاده نمایید.
            </li>
        </ul>
        </v-alert>

        <v-row justify="center" no-gutters>
          <v-col
            v-for="(item, i) in manualVideo"
            :key="i"
            class="pa-2 d-flex flex-column align-start"
            cols="12"
            lg="10"
          >
            <!-- بخش فیلد ورودی و دکمه ها -->
            <div
              class="rowinfo row"
              style="
                width: 100% !important;
                flex-wrap: nowrap !important;
                display: flex !important;
                justify-content: center;
                align-items: baseline;
              "
            >
              <v-text-field
                v-model="item.file_link"
                @input="item.hasError = false"
                :label="item.type === 'iframe' ? 'کد آی فرم ویدئو' : 'لینک ویدئو'"
                :rules="[
                  addVideoRule.required,
                  item.type === 'iframe' ? addVideoRule.url : addVideoRule.link,
                ]"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                outlined
                class="contentinfo"
              >
                <template v-slot:append>
                  <v-btn
                    class="mt-n1 ml-n1"
                    icon
                    @click="
                      () => {
                        item.type = item.type === 'link' ? 'iframe' : 'link';
                        item.file_link = '';
                        item.hasError = false;
                      }
                    "
                  >
                    <v-icon>mdi-{{ item.type === 'iframe' ? 'video-vintage' : 'link' }}</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <help-info
                v-if="i === 0"
                :element-name="`${serviceName}-${componentName}-filelink`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="item.type === 'iframe' ? 'کد آی فرم ویدئو' : 'لینک ویدئو'"
              />
              <v-btn
                v-if="manualVideo.length > 1"
                class="rounded-lg mr-1"
                color="error"
                fab
                outlined
                x-small
                @click="manualVideo.splice(i, 1)"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <help-info
                v-if="manualVideo.length > 1 && i === 0"
                :element-name="`${serviceName}-${componentName}-manualVideo`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="حذف"
              />
              <v-btn
                class="rounded-lg mr-1"
                color="success"
                fab
                outlined
                x-small
                @click="pushVideo"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <help-info
                v-if="i === 0"
                :element-name="`${serviceName}-${componentName}-pushVideo`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="ویدئو"
              />
            </div>

            <!-- بخش پیش‌نمایش ویدیو -->
            <div v-if="item.file_link" class="w-100 d-flex justify-center mt-3" style="width: 100%;">
              <!-- پیش‌نمایش برای آی‌فریم (آپارات) -->
              <iframe
                v-if="item.type === 'iframe' && addVideoRule.url(item.file_link) === true"
                :src="getIframeSrc(item.file_link)"
                width="100%"
                height="250"
                frameborder="0"
                allowfullscreen
                style="border-radius: 8px; max-width: 400px;"
              ></iframe>

              <!-- پیش‌نمایش برای لینک مستقیم -->
              <div v-else-if="item.type === 'link' && addVideoRule.link(item.file_link) === true" class="w-100 d-flex flex-column align-center">
                <video  
                  v-show="!item.hasError"
                  :key="item.file_link" 
                  :src="item.file_link"
                  controls
                  style="width: 100%; max-width: 400px; border-radius: 8px; max-height: 250px"
                  @error="item.hasError = true"
                ></video>

                <!-- پیام خطا در صورت عدم پخش -->
                <div v-if="item.hasError" class="text-center mt-2 p-3" style="background-color: #fff3cd; color: #856404; border: 1px solid #ffeeba; border-radius: 8px; width: 100%; max-width: 400px;">
                  <small style="line-height: 1.8;">
                    امکان افزودن این لینک به دلیل محدودیت‌های سرور مبدأ وجود ندارد.
                    <br>
                  </small>
                </div>
              </div>

            </div>
          </v-col>

          <v-col class="text-left px-2 pb-2" cols="12" lg="10">
            <div class="rowinfo">
              <v-btn
                :disabled="!canAddVideo"
                :loading="loading"
                class="btn-sub ms-auto px-8"
                clear-icon="mdi-close-circle-outline"
                clearable
                color="green lighten-3"
                @click="addVideoManual"
              >
                افزودن
              </v-btn>
              <help-info
                :disabled="!canAddVideo"
                :element-name="`${serviceName}-${componentName}-add-video`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="افزودن"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput";

export default {
  name: "videoByLink",

  components: { SuggestText },

  props: {
    images: Array,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "videoByLink",

      addVideoRule: {
        required: (value) => !!value || "فیلد الزامی میباشد.",
        url: (value) => {
          const pattern = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");
          return pattern.test(value) || "لینک اشتباه";
        },
        link: (value) =>
          this.isDomain(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      },
      manualVideo: [
        {
          title: "",
          file_link: "",
          description: "",
          link: "",
          type: "link",
          hasError: false, // متغیر جدید برای کنترل ارور
        },
      ],
      fromIframe: false,
      loading: false,
    };
  },

  computed: {
    canAddVideo() {
      const _this = this;

      function hasLink(el, index, arr) {
        return (
          typeof _this.addVideoRule[el.type === "iframe" ? "url" : "link"](
            el.file_link,
          ) === "boolean"
        );
      }

      return this.manualVideo.every(hasLink);
    },
    computedImages: {
      get() {
        return this.images;
      },
      set(val) {
        this.$emit("update:images", val);
      },
    },
  },

  methods: {
    getIframeSrc(htmlString) {
      if (!htmlString) return "";
      const match = htmlString.match(/<iframe.*src="(.*?)".*>/);
      return match ? match[1] : "";
    },
    addVideoManual() {
      let mv = this.manualVideo;
      const _this = this;
      let hasIframe = false; 

      function handleType() {
        if (!mv.length) {
          _this.manualVideo = [
            {
              title: "",
              url: "",
              file_link: "",
              description: "",
              link: "",
              type: "link",
              hasError: false, 
            },
          ];

          if (hasIframe) {
            _this.$emit("fetch");
          }
          
          _this.$emit("close");
        } else {
          if (mv[0]?.type === "link") {
            _this.computedImages.push(mv[0]);
            !!mv?.length && mv.shift();
            handleType();
          } else {
            hasIframe = true;
            _this.loading = true;

            let reg = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");
            let v = {
              ...mv[0],
              file_link: reg.exec(mv[0].file_link)?.[1] ?? mv[0].file_link,
            };

            _this
              .getAparatVideoInfo(v.file_link)
              .then(({ data }) => {
                v.title = data.title;
                v.description = data.description;
                saveAparat(v);
              })
              .catch(({ response }) => {
                saveAparat(v);
              });
          }
        }
      }

      function saveAparat(obj) {
        _this.$api
          .post("/user/aparat/default", obj)
          .then(({ data }) => {
            try {
              !!mv?.length && mv.shift();
              handleType();
            } catch (e) {
              console.log(e);
            }
          })
          .catch(({ response }) => {
            _this.$toast.warning("افزودن ویدئو به گالری با خطا روبرو شد.");
          })
          .finally(() => {
            if(!mv.length) _this.loading = false;
          });
      }

      handleType();
    },

    pushVideo() {
      this.manualVideo.push({
        title: "",
        file_link: "",
        description: "",
        link: "",
        type: "link",
        hasError: false,
      });
    },
    // isDomain(str) {
    //   var regex = new RegExp(
    //     "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
    //   );
    //   var without_regex = new RegExp(
    //     "^([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
    //   );

    //   return regex.test(str) || without_regex.test(str);
    // },
    isDomain(str) {
      const regex = /^(?!http:\/\/)(https:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-\.\@:%_\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/;
      const without_regex = /^([0-9A-Za-z-\.\@:%_\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/;

      return regex.test(str) || without_regex.test(str);
    },
    getAparatVideoInfo(url) {
      return new Promise((resolve, reject) => {
        this.$api
          .get("/user/aparat/info", {
            params: {
              url,
            },
          })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
  },
};
</script>

<style scoped></style>
